<template>
    <div id="inquiry">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                Affaire suivie par {{followedBy}}
            </div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Documents
        </h1>
        <div class="divCard">
            <span class="spanCardtitle">
            Devis
            </span>
            <span class="spanCardtype">
                <i>{{quotStatus}}</i>
            </span>
            <button :disabled="quotStatus ==='pas de devis'" v-on:click="goToQuotationPage(inquiry.quotation._id)" class="logout docBtn">{{quotBtn}}</button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
            Attestation TVA
            </span>
            <span class="spanCardtype">
                <i>{{tvaStatus}}</i>
            </span>
            <button :disabled="tvaStatus ==='pas de fiche TVA'" v-on:click="goToInquiryPage(inquiry.name)" class="logout docBtn">{{tvaBtn}}</button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
            Facture
            </span>
            <span class="spanCardtype">
                <i>{{invStatus}}</i>
            </span>
            <button :disabled="invStatus ==='pas de facture'" v-on:click="goToInvoicePage(inquiry.invoice._id)" class="logout docBtn">{{invBtn}}</button>
        </div>
        <div class="outermargin"></div>
        <h1>Demande {{inquiry.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{inquiry.type}}</h1>
        <div v-if="inquiry.intervention">
            <div v-if="inquiry.intervention.length">
                <div v-for="(item, index) in inquiry.intervention" :key="index">
                    <div class="divCard">
                        <span class="spanCardtitle">
                        {{ item.name}}
                        </span>
                        <span class="spanCardtype">
                            <i>{{getDateOfIntervention(item.planning[0].startTimestamp)}} &nbsp;&nbsp;-&nbsp;&nbsp; {{item.type}}</i>
                        </span>
                        <span class="spanCardstatus">
                        {{item.status}}
                        </span>
                        <button v-on:click="goToInterventionPage(item._id)" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="btnAccordion btnAccordionNone">
                    Aucune intervention sur cette demande
                </span>
            </div>
        </div>
        <div v-else>
            <span class="btnAccordion btnAccordionNone">
                Aucune intervention sur cette demande
            </span>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Inquiry',
        data() {
            return {
                inquiry : {},
                Name:"client",
                followedBy:"ADPR",
                quotStatus:"pas de devis",
                quotBtn:"Valider",
                tvaStatus:"pas de fiche TVA",
                tvaBtn:"Voir",
                invStatus:"pas de facture",
                invBtn:"Voir",
                filAriane: ""
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "home" });
            },
            goToInvoicePage(name){
                if(this.$cookie.get('fromPage') !== "inquiry"){
                    this.$cookie.set('fromPagePrev', this.$cookie.get('fromPage'));
                    this.$cookie.set('fromQueryPrev', this.$cookie.get('fromQuery'));
                }
                this.$cookie.set('fromPage', "inquiry");
                this.$cookie.set('fromQuery', this.$route.query.name);
                this.$router.replace({ name: "invoicepay", query: {name: name, id:this.$route.query.name}});
            },
            goToQuotationPage(name){
                if(this.$cookie.get('fromPage') !== "inquiry"){
                    this.$cookie.set('fromPagePrev', this.$cookie.get('fromPage'));
                    this.$cookie.set('fromQueryPrev', this.$cookie.get('fromQuery'));
                }
                this.$cookie.set('fromPage', "inquiry");
                this.$cookie.set('fromQuery', this.$route.query.name);
                this.$router.replace({ name: "quotation", query: {name: name, id:this.$route.query.name}});
            },
            getDateOfIntervention(timestamp){
                
                var n = new Date(timestamp*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                return  day.substr(-2) + '/' + month.substr(-2) + '/' +y;
                            
            },
            backbtn(){
                this.$cookie.set('currentAriane', this.$cookie.get('currentAriane').substr(0, this.$cookie.get('currentAriane').indexOf("Demande")-33));
                if(this.$cookie.get('fromPage') === "inquiry"){
                    if(this.$cookie.get('fromQuery') !== ""){
                        this.$router.replace({ name: this.$cookie.get('fromPagePrev'), query: {name: this.$cookie.get('fromQueryPrev')} });
                    }
                    else{
                        this.$router.replace({ name: this.$cookie.get('fromPagePrev') });
                    }
                }
                else{
                    if(this.$cookie.get('fromQuery') !== ""){
                        this.$router.replace({ name: this.$cookie.get('fromPage'), query: {name: this.$cookie.get('fromQuery')} });
                    }
                    else{
                        this.$router.replace({ name: this.$cookie.get('fromPage') });
                    }
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client" || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getInquiries();
                }
            },
            async getInquiries(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var nameInq = this.$route.query.name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq)
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    if(this.inquiry.quotation){
                        this.quotStatus = this.inquiry.quotation.status;
                        if(this.quotStatus !== "à signer"){
                            this.quotBtn = "Voir";
                        }
                    }
                    if(this.inquiry.TVAsheet){
                        this.tvaStatus = this.inquiry.TVAsheet.status;
                        if(this.tvaStatus === "à compléter"){
                            this.tvaBtn = "Compléter";
                        }
                    }
                    if(this.inquiry.invoice){
                        this.invStatus = this.inquiry.invoice.status;
                        if(this.invStatus === "à payer"){
                            this.invBtn = "Payer";
                        }
                    }
                    this.followedBy = this.inquiry.userInCharge.address.firstName +" "+this.inquiry.userInCharge.address.lastName;
                    if(this.$cookie.get('currentAriane').indexOf("Demande") > -1){
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane').substr(0, this.$cookie.get('currentAriane').indexOf("Demande")-33));
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Demande "+this.$route.query.name+"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.inquiry.type);
                    }
                    else{
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Demande "+this.$route.query.name+"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.inquiry.type);
                    }
                    this.filAriane = this.$cookie.get('currentAriane');
                }
            },
            goToInterventionPage(name){
                this.$cookie.set('currentInquiry', this.$route.query.name);
                if(this.$cookie.get('fromPage') !== "inquiry"){
                    this.$cookie.set('fromPagePrev', this.$cookie.get('fromPage'));
                    this.$cookie.set('fromQueryPrev', this.$cookie.get('fromQuery'));
                }
                this.$cookie.set('fromPage', "inquiry");
                this.$cookie.set('fromQuery', this.$route.query.name);
                this.$router.replace({ name: "intervention", query: {name: name}});
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #inquiry {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
    .docBtn{
        margin:0px;
        width: 100px;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .card{
        font-family: 'BenchNine', sans-serif;
        margin:10px;
        margin-bottom:10px;
        background-color: #F0F0F0;
        display: inline-block;
        position: relative;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
        padding-top: 10px;
        border-bottom: 2px solid;
        border-color:#00000017;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
    button:disabled, button[disabled] {
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
        cursor: no-drop;
    }
</style>